const e = {
  hashGenerate: {
    schema: {
      method: "post",
      url: "/utils/hash/generate",
      mediaType: "application/json"
    }
  },
  hashVerify: {
    schema: {
      method: "post",
      url: "/utils/hash/verify",
      mediaType: "application/json"
    }
  },
  sort: {
    schema: {
      method: "post",
      url: "/utils/sort/{collection}",
      mediaType: "application/json"
    }
  },
  import: {
    schema: {
      method: "post",
      url: "/utils/import/{collection}",
      mediaType: "multipart/form-data"
    }
  },
  export: {
    schema: {
      method: "post",
      url: "/utils/export/{collection}",
      mediaType: "application/json"
    }
  },
  clearCache: {
    schema: {
      method: "post",
      url: "/utils/cache/clear"
    }
  },
  random: {
    schema: {
      method: "get",
      url: "/utils/random/string"
    }
  }
};
export {
  e as utilsService
};
